import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getAvailableFundsForPortal } from '../../../shared/services/apiGateway';

const EXCLUDED_FUND_FAMILIES = new Set(['OPF']);

function useAvailableFundOfferings() {
  const authType = useSelector((state) => state.auth.authType);
  const [availableFundsForPortal, setAvailableFundsForPortal] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (authType === 'MANAGED') {
      setAvailableFundsForPortal([]);
      setIsError(false);
      setIsLoading(false);
      return undefined;
    }

    const abortController = new AbortController();
    let ignore = false;

    async function fetchData() {
      try {
        setIsError(false);
        setIsLoading(true);
        const response = await getAvailableFundsForPortal(abortController.signal);

        if (!ignore && response !== 'aborted' && response) {
          const availableFunds = Array.isArray(response.availableFunds) ? response.availableFunds : [];
          const filteredFunds = availableFunds.filter((fund) => {
            const fundType = fund?.fundType ? String(fund.fundType).toUpperCase() : '';
            const fundFamily = fund?.fund_family ? String(fund.fund_family).toUpperCase() : '';
            return !EXCLUDED_FUND_FAMILIES.has(fundType) && !EXCLUDED_FUND_FAMILIES.has(fundFamily);
          });
          setAvailableFundsForPortal(filteredFunds);
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          setIsError(true);
        }
      } finally {
        setIsLoading(false);
      }
    }

    fetchData();

    return () => {
      ignore = true;
      abortController.abort();
    };
  }, [authType]);

  return {
    availableFundsForPortal, isLoading, isError,
  };
}

export default useAvailableFundOfferings;
